import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => (
  <div style={{ minHeight: '80vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 16, padding: '0 24px', textAlign: 'center' }}>
    <div style={{ fontSize: 64, lineHeight: 1 }}>404</div>
    <h1 style={{ fontFamily: "Georgia, serif", fontSize: 28, fontWeight: 700, color: 'var(--text)', margin: 0 }}>Page not found</h1>
    <p style={{ fontSize: 15, color: 'var(--muted)', maxWidth: 380, lineHeight: 1.6, margin: 0 }}>
      The page you're looking for doesn't exist or was moved.
    </p>
    <Link
      to="/"
      style={{
        marginTop: 8, display: 'inline-block', padding: '10px 24px',
        background: 'var(--accent)', color: '#fff', borderRadius: 9, fontWeight: 700,
        fontSize: 14, textDecoration: 'none',
      }}
    >
      Back to Home
    </Link>
  </div>
);

export default NotFound;
